export default "__VITE_ASSET__CDnJOHC4__"